import { callAPI, HTTPMethod, getAuthenticatedGetUrl } from "./API";
import { CustomerDocuments, CustomerDocumentsRequest } from "../model/CustomerDocument";

const basePath = (tenantId: string, customerId: string) => `/tenants/${tenantId}/customers/${customerId}/documents`;

export async function getCustomerDocument(tenantId: string, customerId: string): Promise<CustomerDocuments> {
    return await callAPI(basePath(tenantId, customerId), {
        method: HTTPMethod.GET
    });
}

export async function uploadCustomerDocument(tenantId: string, customerId: string, request: CustomerDocumentsRequest): Promise<CustomerDocuments> {
    return await callAPI(basePath(tenantId, customerId), {
        method: HTTPMethod.PUT,
        body: request
    });
}

export async function approveCustomerDocument(tenantId: string, customerId: string): Promise<CustomerDocuments> {
    return await callAPI(basePath(tenantId, customerId), {
        method: HTTPMethod.PATCH
    });
}

export async function refuseCustomerDocument(tenantId: string, customerId: string): Promise<CustomerDocuments> {
    return await callAPI(basePath(tenantId, customerId), {
        method: HTTPMethod.DELETE
    });
}

export async function getCustomerDocumentUrl(tenantId: string, customerId: string, id: string): Promise<string> {
    return getAuthenticatedGetUrl(`${basePath(tenantId, customerId)}/${id}/file`);
}